import { render, staticRenderFns } from "./ServiceTextSandbox.vue?vue&type=template&id=286b4fc2&"
import script from "./ServiceTextSandbox.vue?vue&type=script&lang=js&"
export * from "./ServiceTextSandbox.vue?vue&type=script&lang=js&"
import style0 from "./ServiceTextSandbox.vue?vue&type=style&index=0&id=286b4fc2&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('286b4fc2')) {
      api.createRecord('286b4fc2', component.options)
    } else {
      api.reload('286b4fc2', component.options)
    }
    module.hot.accept("./ServiceTextSandbox.vue?vue&type=template&id=286b4fc2&", function () {
      api.rerender('286b4fc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ServiceTextSandbox.vue"
export default component.exports